import { createNode } from '@glueapp/graph-types';
import { GmailIntegration } from './GmailIntegration';
import { MessageDetail } from './types';

export const GmailRemoveLabelFromEmail = createNode({
    id: 'GMail Remove Label from Email',
    name: 'GMail Remove Label from Email',
    description: 'Remove a label from an Email',
    aiDescription:
        'Requires the Google Mail integration to be connected. Takes an "ID" (string) input port for the Gmail message ID and a "Label" input port that accepts either a single string or an array of strings for the label IDs to remove. Outputs an "Email" (object) port with the updated email details including id, threadId, labelIds, snippet, historyId, and internalDate.',
    category: 'Google Mail',
    color: '#ee4237',
    integration: GmailIntegration,
    inPorts: {
        ID: { kind: 'string' },
        Label: {
            kind: 'union',
            subTypes: [{ kind: 'string' }, { kind: 'array', subType: { kind: 'string' } }],
        },
    },
    outPorts: {
        Email: {
            kind: 'object',
            restriction: 'exact',
            properties: {
                id: { kind: 'string' },
                threadId: { kind: 'string' },
                labelIds: { kind: 'array', subType: { kind: 'string' } },
                snippet: { kind: 'string' },
                historyId: { kind: 'string' },
                internalDate: { kind: 'string' },
            },
        },
    },
    isAsync: true,
    execute: async function (input) {
        const id = input.inPorts.ID as string;
        try {
            const response = await input.integration.callIntegration<MessageDetail>({
                method: 'post',
                url: `https://gmail.googleapis.com//gmail/v1/users/me/messages/${id}/modify`,
                data: {
                    addLabelIds: [],
                    removeLabelIds: Array.isArray(input.inPorts.Label) ? input.inPorts.Label : [input.inPorts.Label],
                },
            });
            return { output: { Email: response.data as {} } };
        } catch {
            return { output: { Email: '' } };
        }
    },
});
